import { render, staticRenderFns } from "./face_config.vue?vue&type=template&id=4f901a84&scoped=true"
import script from "./face_config.vue?vue&type=script&lang=js"
export * from "./face_config.vue?vue&type=script&lang=js"
import style0 from "./face_config.vue?vue&type=style&index=0&id=4f901a84&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f901a84",
  null
  
)

export default component.exports